import { Button, Dialog } from '@buffer-mono/popcorn'
import { useMemo } from 'react'

export const ConfirmationDialog = ({
  count,
  channelName,
  postType,
  onConfirm,
  children,
}: {
  count: number
  channelName: string
  postType: 'post' | 'draft'
  onConfirm: () => void
  children: React.ReactNode
}): JSX.Element => {
  const title = useMemo(() => {
    if (count > 1) {
      return postType === 'post'
        ? 'Add posts to queue?'
        : 'Save posts as drafts?'
    }
    if (count === 0) {
      return 'No posts to add'
    }
    return postType === 'post' ? 'Add post to queue?' : 'Save post as draft?'
  }, [count, postType])

  const description = useMemo(() => {
    if (count === 0) {
      return 'Please ensure there is at least one valid post to add.'
    }
    if (postType === 'post') {
      return (
        <>
          You are about to add{' '}
          <strong>
            {count} post{count > 1 ? 's' : ''}
          </strong>{' '}
          to <strong>{channelName}</strong> queue.
        </>
      )
    }
    return (
      <>
        You are about to save{' '}
        <strong>
          {count} draft{count > 1 ? 's' : ''}
        </strong>{' '}
        for <strong>{channelName}</strong>.
      </>
    )
  }, [count, postType, channelName])

  return (
    <Dialog>
      <Dialog.Trigger>{children}</Dialog.Trigger>
      <Dialog.Content size="medium">
        <Dialog.Header>
          <Dialog.Title>{title}</Dialog.Title>
          <Dialog.Description>{description}</Dialog.Description>
        </Dialog.Header>
        <Dialog.Footer>
          <Dialog.Close>
            <Button variant="tertiary" size="large">
              {count > 0 ? 'Cancel' : 'Close'}
            </Button>
          </Dialog.Close>
          {count > 0 && (
            <Dialog.Close>
              <Button variant="primary" size="large" onClick={onConfirm}>
                Confirm
              </Button>
            </Dialog.Close>
          )}
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
